/**
 * List of variant for Sticker
 */
export var StickerVariant;
(function (StickerVariant) {
    StickerVariant["PRIMARY"] = "PRIMARY";
    StickerVariant["SECONDARY"] = "SECONDARY";
    StickerVariant["TERTIARY"] = "TERTIARY";
    StickerVariant["REFURB"] = "REFURB";
})(StickerVariant || (StickerVariant = {}));
/**
 * List of available Markup
 */
export var StickerMarkup;
(function (StickerMarkup) {
    StickerMarkup["DIV"] = "div";
    StickerMarkup["P"] = "p";
    StickerMarkup["SPAN"] = "span";
})(StickerMarkup || (StickerMarkup = {}));
//# sourceMappingURL=StickerEnum.js.map